export function announcementBar() {
    const $body = $("body");
    const $headerBanner = $(".announcement-bar");
    const $headerBannerClose = $headerBanner.find(".close");

    $headerBannerClose.on("click", function (e) {
        e.preventDefault();
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = "announcementBanner=yes; path=/; expires=" + expiry.toGMTString();
        $headerBanner.slideUp(500);
        $body.removeClass("banner-show")
        setTimeout(function () {
            $headerBanner.remove();
            $body.addClass("banner-hide");
        }, 500);
    });

    if ($headerBanner.length && document.cookie.indexOf("announcementBanner=") >= 0) {
        $body.addClass("banner-hide")
        $headerBanner.remove();
    } else {
        if ($headerBanner.length && !$headerBanner.hasClass("banner-hide")) {
            $body.addClass("banner-show")
            setTimeout(function () {
                if (!$headerBanner.hasClass("banner-hide")) {
                    $headerBanner.slideDown(500);
                }
            }, 300);
        }
    }
    if (!$headerBanner.length) {
        $body.addClass("banner-hide")
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/announcementBar.js